import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CurrencyService implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const currency = sessionStorage.getItem('currency')!;
    let params = req.params;
    if (currency) {
      params = params.set('currency', currency);
    }
    const modifiedReq = req.clone({
      params: params,
    });
    return next.handle(modifiedReq);
  }
}
